// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyFeedOverrideWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  FeedOverrideSectionsResponseWebDto,
  GetFeedOverrideSectionsRequestDto,
  SetFeedOverrideSectionRequestDto,
} from '../..';

export const RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_Path =
  '/api/web/v1/users/properties/feedOverrides/getFeedOverrideSections';

/**
 * Return the per-section feed-override enabled state for a listing
 */
export const RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections = (
  postData: GetFeedOverrideSectionsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetFeedOverrideSectionsRequestDto, FeedOverrideSectionsResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyFeedOverrideWebApiHandler_getFeedOverrideSections_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection_Path =
  '/api/web/v1/users/properties/feedOverrides/setFeedOverrideSection';

/**
 * Enable or disable feed overrides for a section of a listing
 */
export const RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection = (
  postData: SetFeedOverrideSectionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetFeedOverrideSectionRequestDto, FeedOverrideSectionsResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyFeedOverrideWebApiHandler_setFeedOverrideSection_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
